import React from 'react';
import './MenuItem.css';

const MenuItem = props => {

    let subMenu = null;
    if(props.subMenuItems!=null && props.subMenuItems.length>0){
        subMenu = (
            <div className="menu-dropdown">
                {props.subMenuItems.map((item, index)=>{
                    return (
                        <div className="menu-dropdown-item" key={''+index} onClick={()=>props.changeService(item.serviceKey)}>
                            {/*<i className="fas fa-hand-point-right" />*/}
                            <div className="menu-dropdown-item-label">
                                {item.label}
                            </div>
                            <div className="menu-dropdown-item-desc">
                                {item.desc}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
    return (
        <div className="menu-item">
            <span className="menu-item-label" >{props.label}</span>
            {subMenu}
        </div>
    )
};

export default MenuItem;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/Menu/MenuItem/MenuItem.js